import { render, staticRenderFns } from "./arpaymfrm.vue?vue&type=template&id=3cfc85a0"
import script from "./arpaymfrm.vue?vue&type=script&lang=js"
export * from "./arpaymfrm.vue?vue&type=script&lang=js"
import style0 from "./arpaymfrm.vue?vue&type=style&index=0&id=3cfc85a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports